<template>
<v-container fill-height fluid class="pt-0 pb-0" >
  <v-row style="height:100%;" v-if="!$vuetify.breakpoint.smAndDown">
    <v-col cols="7" class="pa-0">
      <v-card color="transparent" flat width="100%" height="100%">
        <v-card color="transparent" style="position:absolute;" width="100%" height="100%" flat/>
          <v-carousel
            cycle
            hide-delimiters
            show-arrows-on-hover
            max-width="100%"
            height="100%"
            class="rounded-0"
          >
            <v-carousel-item
              src="assets/emirates-arena.jpg"
              contain
            >
            </v-carousel-item>
            <v-carousel-item
              src="assets/waic-glasgow24.png"
              contain
            >
            </v-carousel-item>
          </v-carousel>
      </v-card>
    </v-col>
    <v-col cols="5" class="pt-4 pb-4" >
      <v-card height="100%" color="transparent" flat>

        <div class="competition-language-select">
          <v-btn
            icon
            disabled
            @click="CompetitionEnglish()"
            width="24px" 
            height="24px"
          >
            <v-img src="/assets/uk-flag-round-circle-icon.png" width="24px" height="24px" alt="English"></v-img>
          </v-btn>
          <v-btn 
            icon
            @click="CompetitionHungarian()"
            width="24px" 
            height="24px"
            class="ml-1"
          >
            <v-img src="/assets/hungary-flag-round-circle-icon.png" width="24px" height="24px" alt="Magyar"></v-img>
          </v-btn>
        </div>

        <h1 style="color:black;font-family:waHeadline;font-size:20px" class="mt-0 pt-0">
          FREE PRIZE DRAW - Glasgow 2024
        </h1>
        <p style="color:black;font-family:waRegular;white-space: pre-line;font-size:14px;">
          Enter for a chance to win a four-night holiday for TWO people to the World Athletics Indoor Championships in Glasgow, Scotland (GBR) - 29 February to 3 March 2024. Flights (economy), hotel (twin room, bed & breakfast basis) and VIP accreditations to watch the three-days of competition included. <a href="https://worldathletics.org/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms & Conditions.</a>
        </p>
        <p style="color:black;font-family:waRegular;white-space: pre-line;font-size:12px;">
          The information submitted will only be used to contact you if your entry is successful. It will be deleted after the competition ends. <a href="https://www.worldathletics.org/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy.</a>
        </p>
        <v-form ref="form" v-model="validForm">
          <v-row>
            <v-col cols="12" class="pb-0 pt-0">
              <v-text-field v-model="fullname" light filled dense outlined label="Full Name" :rules="[rules.required]"> </v-text-field>
            </v-col>
            <v-col cols="12" class="pb-0 pt-0">
              <v-text-field v-model="email" light  filled dense outlined label="Email" :rules="[rules.required, rules.email]"> </v-text-field>
            </v-col>
            <v-col cols="6" class="pb-0 pt-0">
              <v-text-field v-model="addressOne" dense filled light outlined label="Address Line 1"/>
            </v-col>
            <v-col cols="6" class="pb-0 pt-0">
              <v-text-field v-model="addressTwo" dense filled light outlined label="Address Line 2"/>
            </v-col>
            <v-col cols="6" class="pb-0 pt-0">
              <v-text-field v-model="townCity" dense filled light outlined label="Town/City" :rules="[rules.required]"/>
            </v-col>
            <v-col cols="6" class="pb-0 pt-0">
              <v-text-field v-model="countyOrState" dense filled light outlined label="County / State" :rules="[rules.required]"/>
            </v-col>
            <v-col cols="6" class="pb-0 pt-0">
              <v-text-field v-model="country" dense filled light outlined label="Country" :rules="[rules.required]"/>
            </v-col>
            <v-col cols="6" class="pb-0 pt-0">
              <v-text-field v-model="postCode" dense filled light outlined label="Postcode" :rules="[rules.required]"/>
            </v-col>

            <v-col cols="12" class="pb-0 pt-0">
              <v-checkbox
                v-model="promotionalOffers"
                label="Yes, I would like World Athletics to send me information and special offers relating to athletics and athletics events."
                class="pt-0 pb-2 mt-0 checkbox-promo"
                hide-details
              ></v-checkbox>
            </v-col>

            <v-col cols="8" class="pb-0 pt-0" v-if="!submitSuccess">
              <div id="captcha_container" data-sitekey="6LeKYrAeAAAAAOYiHMJaYNOivuvXlanfDQgs8k7Z"></div>
            </v-col>
            <v-col cols="4" class="pb-0 pt-0">
              <v-btn color="green" :disabled="!capchaComplete || submitSuccess" block light style="right:0px;color:white;" @click="OnSubmit">Submit</v-btn>
              <p v-if="submitSuccess" style="color:green;font-family:waRegular;white-space: pre-line;font-size:12px;">{{submitMessage}} </p>
              <p v-else-if="!submitSuccess" style="color:red;font-family:waRegular;white-space: pre-line;font-size:12px;">{{submitMessage}} </p>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
  <v-row style="height:100%;" v-else>
    <v-col cols="12" class="pb-0">
      <v-card color="transparent" flat width="100%" height="100px">
         <v-carousel
            cycle
            hide-delimiters
            show-arrows-on-hover
            max-width="100%"
            height="100%"
            class="rounded-0"
          >
            <v-carousel-item
              src="assets/emirates-arena.jpg"
              contain
            >
            </v-carousel-item>
            <v-carousel-item
              src="assets/waic-glasgow24.png"
              contain
              >
            </v-carousel-item>
          </v-carousel>
      </v-card>
    </v-col>
    <v-col cols="12" class="pt-0 pb-0">
      <v-card height="100%" color="transparent" flat>

        <div class="competition-language-select">
          <v-btn
            icon
            disabled
            @click="CompetitionEnglish()"
            width="48px" 
            height="48px"
          >
            <v-img src="/assets/uk-flag-round-circle-icon.png" width="48px" height="48px" alt="English"></v-img>
          </v-btn>
          <v-btn 
            icon
            @click="CompetitionHungarian()"
            width="48px" 
            height="48px"
            class="ml-1"
          >
            <v-img src="/assets/hungary-flag-round-circle-icon.png" width="48px" height="48px" alt="Magyar"></v-img>
          </v-btn>
        </div>

        <h1 style="color:black;font-family:waHeadline;font-size:20px" class="mt-0 pt-0">
          FREE PRIZE DRAW - Glasgow 2024
        </h1>
        <p style="color:black;font-family:waRegular;white-space: pre-line;font-size:14px;">
          Enter for a chance to win a four-night holiday for TWO people to the World Athletics Indoor Championships in Glasgow, Scotland (GBR) - 29 February to 3 March 2024. Flights (economy), hotel (twin room, bed & breakfast basis) and VIP accreditations to watch the three-days of competition included. <a href="https://worldathletics.org/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms & Conditions.</a>
        </p>
        <p style="color:black;font-family:waRegular;white-space: pre-line;font-size:12px;">
          The information submitted will only be used to contact you if your entry is successful. It will be deleted after the competition ends. <a href="https://www.worldathletics.org/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy.</a>
        </p>
        <v-form ref="form" v-model="validForm">
          <v-row>
            <v-col cols="12" class="pb-0 pt-0">
              <v-text-field v-model="fullname" light filled dense outlined label="Full Name" :rules="[rules.required]"> </v-text-field>
            </v-col>
            <v-col cols="12" class="pb-0 pt-0">
              <v-text-field v-model="email" light  filled dense outlined label="Email" :rules="[rules.required, rules.email]"> </v-text-field>
            </v-col>
            <v-col cols="12" class="pb-0 pt-0">
              <v-text-field v-model="addressOne" dense filled light outlined label="Address Line 1"/>
            </v-col>
            <v-col cols="12" class="pb-0 pt-0">
              <v-text-field v-model="addressTwo" dense filled light outlined label="Address Line 2"/>
            </v-col>
            <v-col cols="6" class="pb-0 pt-0">
              <v-text-field v-model="townCity" dense filled light outlined label="Town/City" :rules="[rules.required]"/>
            </v-col>
            <v-col cols="6" class="pb-0 pt-0">
              <v-text-field v-model="countyOrState" dense filled light outlined label="County / State" :rules="[rules.required]"/>
            </v-col>
            <v-col cols="6" class="pb-0 pt-0">
              <v-text-field v-model="country" dense filled light outlined label="Country" :rules="[rules.required]"/>
            </v-col>
            <v-col cols="6" class="pb-0 pt-0">
              <v-text-field v-model="postCode" dense filled light outlined label="Postcode" :rules="[rules.required]"/>
            </v-col>

            <v-col cols="12" class="pb-0 pt-0">
              <v-checkbox
                v-model="promotionalOffers"
                label="Yes, I would like World Athletics to send me information and special offers relating to athletics and athletics events."
                class="pt-0 pb-2 mt-0 checkbox-promo"
              ></v-checkbox>
            </v-col>

            <v-col cols="12" class="pb-0 pt-0" v-if="!submitSuccess">
              <div id="captcha_container" data-sitekey="6LeKYrAeAAAAAOYiHMJaYNOivuvXlanfDQgs8k7Z"></div>
            </v-col>
            <v-col cols="12" class="pb-0">
              <v-btn color="green" :disabled="!capchaComplete || submitSuccess" light block  style="right:0px;color:white;" @click="OnSubmit">Submit</v-btn>
              <p v-if="submitSuccess" style="color:green;font-family:waRegular;white-space: pre-line;font-size:12px;">{{submitMessage}} </p>
              <p v-else-if="!submitSuccess" style="color:red;font-family:waRegular;white-space: pre-line;font-size:12px;">{{submitMessage}} </p>
            </v-col>
          </v-row>
        </v-form>
        
      </v-card>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
import {mapMutations} from 'vuex'
import axios from 'axios';

  export default {
    name: 'CompetitionView',
    components: {

    },
    props: {
      
      touchpointName : ""
    },
    computed: {
    },

    mounted () {

       grecaptcha.render('captcha_container', {
        'sitekey' : '6LeKYrAeAAAAAOYiHMJaYNOivuvXlanfDQgs8k7Z',
        'callback' : (response) => {
          this.token = response;
          this.capchaComplete = true;
        }
      });

    },
    data: () => ({
      token : "",
      capchaComplete : false,
      submitMessage : "",
      submitSuccess : false,
      valid : null,
      fullname : "",
      email : "",
      addressOne : "",
      addressTwo : "",
      townCity : "",
      countyOrState : "",
      country : "",
      postCode : "",
      promotionalOffers : false,
      validForm : false,
      rules: {
        required: value => !!value || 'Required.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      }
    }),
    methods: {

      ...mapMutations("sessionState", [
        "AddCustomSessionData",
        "ClearCustomSessionDataOfKey"
       
      ]),

      ResetForm()
      {
        grecaptcha.reset();
        this.capchaComplete = false;
      },
      OnSubmit()
      {
        this.submitMessage = "";
        if (this.$refs.form.validate())
        {
          let sendObj = {touchpointName : this.touchpointName, token : this.token, fullname : this.fullname, email : this.email, addressOne : this.addressOne, addressTwo : this.addressTwo, townCity : this.townCity, country : this.country, postCode : this.postCode, countyOrState : this.countyOrState, promotionalOffers : this.promotionalOffers };

          axios.post("https://mowaemailmicroservice.azurewebsites.net/email/sendcompetition",sendObj).then((response) => {

            this.ResetForm();
            if(response.data == "Success")
            {
              this.submitMessage = "Submitted Successfully";
              this.submitSuccess =  true;
            }
            else
            {
              this.submitMessage = "Email or reCaptcha failed, please try again";
              this.submitSuccess = false;
            }
          });
        }
        else
        {
          this.submitMessage = "Please fill required fields";
        }
      },
      CompetitionHungarian()
        {
          this.ClearCustomSessionDataOfKey("glasgowCompetitionLanguage");
          this.AddCustomSessionData({key: "glasgowCompetitionLanguage", value : 1});
        }

    },
    watch: {
      
    }
  }
</script>
